// extracted by mini-css-extract-plugin
export default {"selectArea":"tags_suggestions-module___selectArea___aa9d913e","suggestions":"tags_suggestions-module___suggestions___cd818505"};